import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";

const SPECIALTIES = ["ICU", "ER", "Med-Surg", "OR", "Cath Lab", "Respiratory Therapy", "Physical Therapy", "Radiology"];

export default function PostShift() {
  const nav = useNavigate();
  const now = new Date();
  const tomorrow = new Date(now.getTime() + 24 * 3600 * 1000);
  const toLocal = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);

  const [form, setForm] = useState({
    title: "ICU Night Shift", specialty: "ICU", shift_type: "Night",
    start_time: toLocal(tomorrow), end_time: toLocal(new Date(tomorrow.getTime() + 12 * 3600 * 1000)),
    hourly_rate: 85, city: "Houston", state: "TX", certification_required: "BLS, ACLS", notes: "",
  });
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/shifts", { ...form, hourly_rate: Number(form.hourly_rate), start_time: new Date(form.start_time).toISOString(), end_time: new Date(form.end_time).toISOString() });
      toast.success("Shift posted");
      nav("/dashboard/manage-shifts");
    } catch (e2) { toast.error(formatApiError(e2)); } finally { setLoading(false); }
  };

  return (
    <div className="max-w-3xl space-y-6" data-testid="post-shift-page">
      <div>
        <div className="overline text-trital-red">Facility</div>
        <h1 className="mt-1 font-display font-black text-3xl lg:text-4xl text-slate-900 tracking-tight">Post PRN Shift</h1>
      </div>
      <form onSubmit={submit} className="rounded-2xl bg-white border border-slate-200 p-6 shadow-card grid md:grid-cols-2 gap-4">
        <F label="Title" value={form.title} onChange={upd("title")} span testid="post-shift-title" />
        <div>
          <L>Specialty</L>
          <select value={form.specialty} onChange={upd("specialty")} className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-300">
            {SPECIALTIES.map((s) => <option key={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <L>Shift Type</L>
          <select value={form.shift_type} onChange={upd("shift_type")} className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-300">
            {["Day", "Night", "Evening"].map((s) => <option key={s}>{s}</option>)}
          </select>
        </div>
        <F label="Start Time" type="datetime-local" value={form.start_time} onChange={upd("start_time")} />
        <F label="End Time" type="datetime-local" value={form.end_time} onChange={upd("end_time")} />
        <F label="Hourly Rate ($)" type="number" value={form.hourly_rate} onChange={upd("hourly_rate")} />
        <F label="City" value={form.city} onChange={upd("city")} />
        <F label="State" value={form.state} onChange={upd("state")} />
        <F label="Certification Required" value={form.certification_required} onChange={upd("certification_required")} span />
        <div className="md:col-span-2">
          <L>Notes</L>
          <textarea rows={3} value={form.notes} onChange={upd("notes")} className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-300"></textarea>
        </div>
        <div className="md:col-span-2">
          <button disabled={loading} className="px-5 py-3 rounded-full bg-trital-navy text-white font-semibold btn-lift hover:bg-trital-navy-deep disabled:opacity-60" data-testid="post-shift-submit">{loading ? "Posting…" : "Post shift"}</button>
        </div>
      </form>
    </div>
  );
}
const L = ({ children }) => <label className="text-xs font-bold uppercase tracking-wider text-slate-600">{children}</label>;
const F = ({ label, type = "text", value, onChange, span, testid }) => (
  <div className={span ? "md:col-span-2" : ""}>
    <L>{label}</L>
    <input type={type} value={value} onChange={onChange} className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-300 focus:ring-2 focus:ring-trital-navy/30 focus:border-trital-navy outline-none" data-testid={testid} />
  </div>
);
